module.exports = __webpack_public_path__ + "img/2.783f04dc.jpg";